import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export const geoTabs = [
  {
    label: "Getting started",
    isHeader: true,
  },
  {
    label: "Advanced Compliance Technology",
    slug: "advanced-compliance-technology"
  },
  {
    label: "Admin Console",
    slug: "admin-console"
  },
  {
    label: "Customer Onboarding",
    slug: "onboarding"
  },
  {
    label: "ACT Geosafe",
    isHeader: true,
  },
  {
    label: "Overview",
    slug: "geo-overview"
  },
  {
    label: "SDK Integration (iOS)",
    slug: "sdk-ios"
  },
  {
    label: "SDK Integration (Android)",
    slug: "sdk-android"
  },
  {
    label: "SDK Integration (React Native)",
    slug: "sdk-react-native"
  },
  {
    label: "SDK Integration (.NET MAUI)",
    slug: "sdk-xamarin"
  },
  {
    label: "Build with LLM",
    slug: "geo-build-with-llm"
  },
  {
    label: "ACT Geosafe (Web)",
    isHeader: true,
  },
  {
    label: "Overview",
    slug: "verify-overview"
  },
  {
    label: "SDK Integration (Web)",
    slug: "sdk-web"
  },
  {
    label: "Backend Integration",
    slug: "web-backend-integration"
  },
  {
    label: "Build with LLM",
    slug: "verify-build-with-llm"
  },
];

export function getIndexFromSlug(slug) {
  const contentTabs = geoTabs.filter((t) => !t.isHeader);
  const index = contentTabs.findIndex((t) => t.slug === slug);
  return index >= 0 ? index : 0;
}

export function getSlugFromIndex(index) {
  const contentTabs = geoTabs.filter((t) => !t.isHeader);
  return contentTabs[index]?.slug ?? contentTabs[0].slug;
}

export default function GeoTabs({ value, onChange }) {
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    const headersBefore = geoTabs
      .slice(0, newValue)
      .filter((t) => t.isHeader).length;
    const actualContentIndex = newValue - headersBefore;

    const slug = getSlugFromIndex(actualContentIndex);
    navigate(`/introduction/${slug}`);

    onChange(actualContentIndex);
  };

  let visualIndex = 0;
  let clickableCount = 0;

  for (let i = 0; i < geoTabs.length; i++) {
    if (!geoTabs[i].isHeader) {
      if (clickableCount === value) {
        visualIndex = i;
        break;
      }
      clickableCount++;
    }
  }

  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      value={visualIndex}
      onChange={handleChange}
      sx={{
        width: "100%",
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: "400",
          fontSize: "14px",
          minHeight: 40,
          alignItems: "flex-start",
          textAlign: "left",
          borderBottom: "0.1rem #d8d8d8 solid",
          "&:hover": {
            backgroundColor: " #e3e3e3",
          },
        },
        "& .Mui-selected": {
          color: "#e54f9c !important",
          backgroundColor: "#fcd4e9",
        },
        "& .MuiTabs-indicator": {
          width: 0,
        },
      }}
    >
      {geoTabs.map((tab, index) => (
        <Tab
          key={`${tab.label}-${index}`}
          label={tab.label}
          disabled={tab.isHeader}
          {...a11yProps(index)}
          sx={{
            ...(tab.isHeader && {
              opacity: "1 !important",
              color: "#fff !important",
              fontWeight: "bold !important",
              fontSize: "12px",
              backgroundColor: "#000000",
              cursor: "default",
              pointerEvents: "none",
              letterSpacing: "0.05rem",
              marginTop: "0",
            }),
          }}
        />
      ))}
    </Tabs>
  );
}
